angular.module('rjmNg.directives').directive "dynamicTooltip", [
  "$timeout"
  ($timeout) ->
    restrict: "A"
    link: (scope, elm, attrs) ->

      applyTooltip = (title) ->
        # timeout to wait for any other dom transformations to complete 
        # before checking elm offsetWidth and scrollWidth
        $timeout ->
          if elm[0].offsetWidth < elm[0].scrollWidth and title isnt ""
            elm.tooltip
              title: title
              placement: "top"
          else
            elm.tooltip "destroy"
      attrs.$observe "title", (title) ->
       applyTooltip(title)

      stopListening = (liseners) ->
        for listener in liseners
          listener()
      # {
      #  modelName: string | ['event1', 'event2'...]
      # }
      scopeEventListeners = []
      scopeEventsWatcher = scope.$watch attrs.scopeEvents, (events, old) ->
        unless events?
          return

        stopListening(scopeEventListeners)

        if typeof events is "string"
          events = [events]
        for event in events
          listener = scope.$on event, (event) ->
            applyTooltip(attrs.title)
          scopeEventListeners.push listener


      # {
      #  modelName: ['property1', 'propeerty2'...]
      # }
      modelListeners = []
      modelsWatcher = scope.$watch attrs.models, (models, old) ->
        unless events?
          return

        stopListening(modelListeners)

        for model, properties of models
          for prop in properties
            listener = scope.$watch "#{model}.#{prop}", (model, old) ->
              if model is old
                return
              applyTooltip(attrs.title)
            modelListeners.push listener

      elm.on "$destroy", (event) ->
        scopeEventListener?()
        modelsWatcher()
        scopeEventsWatcher()

        stopListening(modelListeners)
        stopListening(scopeEventListeners)
]
